import React              from 'react';
import useGET             from 'rest/useGET';
import { useLocation }    from 'react-router-dom';
import usePOST            from 'rest/usePOST';
import useStyles          from './loginPageStyles'
import { useTranslation } from 'react-i18next';

import Alert      from 'components/Alert';
import Container  from '@mui/material/Container';
import { getErrorMessage } from 'rest/sendRequest';
import { getUsernameFromToken } from 'App';
import LoginForm  from 'pages/LoginPage/LoginForm';
import { Navigate } from 'react-router-dom';
import Paper      from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { BACKEND_PATHS } from 'rest/const';
import { AuthContext }   from 'App';
import INTERNAL_PATHS    from 'routing/internalPaths';


function LoginPage() {

  const { t }                     = useTranslation();
  const { classes }               = useStyles();
  const { userInfo, setUserInfo } = React.useContext(AuthContext);

  const location = useLocation();

  const [alert, setAlert]           = React.useState(undefined);
  const [submitData, setSubmitData] = React.useState(undefined);

  const [autoLoginPath, setAutoLoginPath] = React.useState(BACKEND_PATHS.autoLogin);
  useGET(autoLoginPath, undefined, {
    onError:            () => setAutoLoginPath(null), //null path = don't retry
    onSuccess:          (res) => {
      setAutoLoginPath(null); //null path = don't retry
      if (!res.data) {
        return;
      }
      setUserInfo({
        ...res.data,
        username: getUsernameFromToken(res.data.accessToken),
      });
    },
  });

  function handleLogin(res) {
    setSubmitData(null);
    const data     = res.data;
    const userInfo = {
      username: submitData?.credentials?.username,
      ...data,
    };
    setUserInfo(userInfo);

    if (process.env.NODE_ENV === 'development') {
      console.log('LoginPage, onRestSuccess: ', res.data);
    }
  }

  function onRestError(err) {
    //TODO add more specific handling when API is developed
    setSubmitData(null);
    if (err.response && err.response.data.isAlert) {
      setAlert(err.response.data);
    } else {
      setAlert({
        msgTranslKey: 'serverError',
        type:         'warning',
      });
    }

    if (process.env.NODE_ENV === 'development') {
      console.log('LoginPage, onRestError: ', getErrorMessage(err), err.response, err);
      console.error('LoginPage, onRestError: ', err);
    }
  }

  const swrOptions = {
    shouldRetryOnError: false,
    onSuccess:          handleLogin,
    onError:            onRestError,
  };

  const path                     = submitData ? BACKEND_PATHS.login : null;
  const { isValidating, mutate } = usePOST(path, submitData, undefined, swrOptions);

  function handleSubmit(evt) {
    evt.preventDefault();
    const formData      = new FormData(evt.target);
    const toBeSubmitted = {
      credentials: {
        type: 'EMAIL',
      },
    };

    for (const [key, value] of formData.entries()) {
      toBeSubmitted.credentials[key] = value;
    }
    //TODO add encryption
    setSubmitData(toBeSubmitted);
    mutate();
  }

  if (userInfo) {
    const navigateTo = location?.state?.goBackTo || INTERNAL_PATHS.cardsInfo;
    return <Navigate to={navigateTo}/>
  }

  return (
    <Container maxWidth='xs'>
      <Alert alert={alert} setAlert={setAlert}/>
      <Paper elevation={6} className={classes.mainPaper}>
        <Paper elevation={0} className={classes.titlePaper}>
          <Typography
            align='center'
            variant='subtitle1'
            className={classes.title}
          >
            {t('loginTitle')}
          </Typography>
        </Paper>
        <LoginForm onSubmit={handleSubmit} isInProgress={isValidating}/>
      </Paper>
    </Container>
  );
}

export default LoginPage;